<template>
  <SlideOver :open="on" @close="close">
    <div class="w-screen max-w-md h-full">
      <form
        @submit.prevent="storeEquipment"
        class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
      >
        <div class="flex-1 h-0 overflow-y-auto">
          <div class="py-6 px-4 bg-light-blue-700 sm:px-6">
            <div class="flex items-center justify-between">
              <h2
                id="slide-over-heading"
                class="text-lg font-medium text-white"
              >
                {{ t("equipment_create") }}
              </h2>
              <div class="ml-3 h-7 flex items-center">
                <button
                  type="button"
                  @click="close()"
                  class="
                    bg-light-blue-700
                    rounded-md
                    focus:outline-none focus:ring-2 focus:ring-white
                  "
                >
                  <XIcon class="h-6 w-6 hover:text-white text-light-blue-200" />
                </button>
              </div>
            </div>
            <div class="mt-1">
              <p class="text-sm text-light-blue-300">
                {{ t("description") }}
              </p>
            </div>
          </div>
          <div class="flex-1 flex flex-col justify-between">
            <div class="px-4 divide-y divide-gray-200 sm:px-6">
              <div class="space-y-6 pt-6 pb-5">
                <ui-input
                  ref="identifier"
                  :invalid="'identifier' in form.errors"
                  :error="form.errors.identifier"
                  type="text"
                  :label="t('identifier')"
                  v-model="form.identifier"
                ></ui-input>

                <ui-input
                  :invalid="'serial_number' in form.errors"
                  :error="form.errors.serial_number"
                  type="text"
                  :label="t('serial_number')"
                  v-model="form.serial_number"
                ></ui-input>

                <ui-input
                  :invalid="'brand' in form.errors"
                  :error="form.errors.brand"
                  type="text"
                  :label="t('brand')"
                  v-model="form.brand"
                ></ui-input>

                <ui-input
                  :invalid="'model' in form.errors"
                  :error="form.errors.model"
                  type="text"
                  :label="t('model')"
                  v-model="form.model"
                ></ui-input>

                <ui-input
                  :invalid="'next_calibration_on' in form.errors"
                  :error="form.errors.next_calibration_on"
                  type="date"
                  :label="t('next_calibration_on')"
                  v-model="form.next_calibration_on"
                  :cornerHint="t('optional')"
                ></ui-input>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-shrink-0 px-4 py-4 flex justify-end">
          <ui-button
            backgroundStyling="bg-white"
            borderStyling="border border-gray-300"
            textColorStyling="text-gray-700 hover:text-gray-500"
            type="button"
            @click="close"
            >{{ t("cancel") }}</ui-button
          >

          <ui-button :disabled="form.processing" type="submit" class="ml-4">
            {{ t("save") }}
          </ui-button>
        </div>
      </form>
    </div>
  </SlideOver>
</template>

<script>
import { XIcon } from "@heroicons/vue/outline";
import { useI18n } from "vue-i18n";
import SlideOver from "@/Shared/SlideOver";

export default {
  emits: ["toggleVisibility"],

  components: {
    XIcon,
    SlideOver,
  },

  props: {
    on: { type: Boolean, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  mounted() {
    if (this.on) {
      setTimeout(() => {
        this.$refs.identifier.$refs.input.focus();
      }, 250);
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: "POST",
        brand: "",
        model: "",
        serial_number: "",
        identifier: "",
        next_calibration_on: "",
      }),
    };
  },

  methods: {
    storeEquipment() {
      this.form.post(
        this.route("equipment.store", {
          search: this.$page.props.filters.search,
        }),
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.close();
          },
        }
      );
    },

    close() {
      this.form.reset();
      this.form.clearErrors();
      this.$emit("toggleVisibility");
    },
  },

  watch: {
    on: {
      handler: (on) => {
        if (on) {
          setTimeout(() => {
            this.$refs.identifier.$refs.input.focus();
          }, 250);
        }
      },
    },
  },
};
</script>


<i18n>
{
  "es": {
    "equipment_create": "Crear nuevo equipo",
    "description": "Establece la información del equipo",
    "brand": "Marca",
    "model": "Modelo",
    "serial_number": "Número de serie",
    "identifier": "Identificador",
    "next_calibration_on": "Siguiente calibración",
    "save": "Guardar",
    "optional": "opcional",
    "cancel": "Cancelar"
  }
}
</i18n>
